import type { SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";
import classnames from "classnames";
import { TinyBody } from "helpers/TypographyComponents";
import type { ReactNode } from "react";

interface Props {
    children: ReactNode;
    sx?: SxProps<Theme>;
    className?: string;
    helperText?: string;
}

export default function BaseCell({ children, sx, className, helperText }: Props) {
    return (
        <Box
            data-testid="base-cell-box"
            className={classnames("size-full flex flex-col justify-center", className)}
            sx={{
                position: "relative",
                overflow: "hidden",
                ...sx,
            }}
        >
            <div className="flex-none h-[50px]">{children}</div>

            {helperText && (
                <div
                    className="flex-1 flex flex-col flex-end"
                    style={{
                        padding: "2px",
                    }}
                >
                    <TinyBody style={{ textAlign: "left" }}>{helperText}</TinyBody>
                </div>
            )}
        </Box>
    );
}
